import { Role } from '../../enums';

export interface IAuthContext {
    hasAccess: (...roles: Role[]) => boolean;
    isAuthenticated: boolean;
    hasRole: boolean;
    authType: string;
    assembly: string;
    username: string;
}

export interface IAuthenticationContext {
    roles: string[];
    username: string;
    isAuthenticated: boolean;
    authType: string;
    assembly: string;
}

export interface IAuthConfig {
    assembly: string;
    type: string;
}

export interface IAzureAuthConfig {
    scope: string;
    clientId: string;
    tenantId: string;
}

export interface IWinAuthConfig {
    roles: string[];
    username: string;
}

//action types
export const INIT_AZURE_SETTINGS = 'context/authentication/INIT_AZURE_SETTINGS';
export const INIT = 'context/authentication/INIT';

export const actions = {
    initAzureSettings: (config: { username: string; roles: string[] }) => ({
        type: INIT_AZURE_SETTINGS as typeof INIT_AZURE_SETTINGS,
        payload: config
    }),
    init: (config: { authType: string; assembly: string }) => ({
        type: INIT as typeof INIT,
        payload: config
    })
};

export type ActionTypes = ActionUnion<typeof actions>;
